const Config = require('~config/default.env').default;
import axios from 'axios';

export function fetchPaymentMethods(cartId) {
  const params = {
    filter: {
      new_format: true,
      available_for: { $in: 'website' },
      code: { $ne: 'pay_at_cashier' },
    },
    limit: 20,
  };

  if (cartId) {
    params.filter.cart_id = cartId;
  }

  return axios.get(`${Config.MS_PAYMENT_API_URL}/payment-methods`, { params });
}

export function fetchPaymentMethodByCode(payload) {
  return axios.get(`${Config.MS_PAYMENT_API_URL}/payment-methods`, {
    params: {
      filter: { code: payload },
      limit: 1,
    },
  });
}

export function getBanksList() {
  return axios.get(`${Config.MS_PAYMENT_API_URL}/bca-banks`);
}

export function verifyBankDetails(payload) {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/bca-banks/verify`, payload);
}

export function definePaymentMethod({ paymentCode, payload }) {
  return axios.post(
    `${Config.MS_PAYMENT_API_URL}/payments/${paymentCode}`,
    payload,
  );
}

export function callback(payload) {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/payments/callback`, payload);
}

export function fetchListCreditDebitCard() {
  return axios.get(`${Config.MS_PAYMENT_API_URL}/midtrans-tokens`);
}

export function addNewCreditDebitCard(payload) {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/midtrans-token`, payload);
}

export function fetchMidtransToken(payload) {
  return axios.get(`${Config.midtrans.url}/v2/token`, {
    params: {
      client_key: Config.midtrans.client_key,
      bank: 'bca',
      ...payload,
    },
  });
}

export function deleteCreditDebitCardSaved({ _id }) {
  return axios.delete(`${Config.MS_PAYMENT_API_URL}/midtrans-token/${_id}`);
}

export function fetchPaymentPromotions(payload) {
  return axios.post(`${Config.MS_PAYMENT_API_URL}/payment-promotions`, payload);
}

/**
 * Order Refund Request
 * @param {*} orderId
 * @param {*} params
 * @returns
 */
export function refundRequest(orderId, params) {
  return axios.post(
    `${Config.MS_PAYMENT_API_URL}/order/${orderId}/refund`,
    params,
  );
}
